var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.958 8.18125C15.958 12.6031 12.9299 15.75 8.45801 15.75C4.17051 15.75 0.708008 12.2875 0.708008 8C0.708008 3.7125 4.17051 0.25 8.45801 0.25C10.5455 0.25 12.3018 1.01562 13.6549 2.27813L11.5455 4.30625C8.78613 1.64375 3.65488 3.64375 3.65488 8C3.65488 10.7031 5.81426 12.8938 8.45801 12.8938C11.5268 12.8938 12.6768 10.6938 12.858 9.55313H8.45801V6.8875H15.8361C15.908 7.28437 15.958 7.66562 15.958 8.18125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleVector);
export default __webpack_public_path__ + "static/media/Google-Vector.e80f13fd2d9a855005bd55b3f1f7e817.svg";
export { ForwardRef as ReactComponent };